import { createFileRoute } from '@tanstack/react-router';

import { SocialAdTemplatesListView } from 'src/sections/admin/social-ad-templates/social-ad-templates-list-view';

export const Route = createFileRoute('/admin-skidog/social-ad-templates/')({
  component: SocialAdTemplatesPage,
});

function SocialAdTemplatesPage() {
  return <SocialAdTemplatesListView />;
}
